import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';

import { GetFileExtension, getJwt, imageFormats } from ".";

export function clickDownloadElement(part: BlobPart[], nomeArquivo: string, atributoId = 'downloadElement') {
    const url = window.URL.createObjectURL(new Blob(part));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    link.setAttribute('id', atributoId);
    document.body.appendChild(link);
    link.click();
    let element = document.getElementById(atributoId);
    if (element) {
        element.outerHTML = '';
    }
}

export function viewDownloadElement(part: BlobPart[], nomeArquivo: string) {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nomeArquivo);

    if (fileExtension === 'pdf') {
        file = new Blob(part, { type: 'application/pdf' });
        fileUrl = URL.createObjectURL(file);
    }

    if (imageFormats.includes(fileExtension)) {
        file = new Blob(part, { type: 'image/' + fileExtension });
        fileUrl = URL.createObjectURL(file);
    }

    if (fileUrl !== undefined) {
        window.open(fileUrl);
    }
}

interface IArquivo {
    url: string;
    nomeDoArquivo: string;
    atributoId?: string;
}

export const downloadOrViewArquivo = (values: IArquivo, isView = false) => {
    let urlBase = window.location.origin;
    trackPromise(
        Axios.get(urlBase + values.url, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {

            if (isView) {
                viewDownloadElement(
                    [resp.data],
                    values.nomeDoArquivo,
                );
            } else {
                clickDownloadElement(
                    [resp.data],
                    values.nomeDoArquivo,
                    values.atributoId || 'downloadArquivo'
                );
            }
        }),
    );
};